<template>
  <div
    :class="['GridContainer']"
    :style="{ 'grid-template-columns': `repeat(${column}, 1fr)` }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  props: {
    text: String,
    isActive: {
      type: Boolean,
      default: false,
    },
    column: {
      type: Number,
      default: 1,
    },
    variant: {
      type: Object,
      default: () => ({}),
    },
  },
  created () {},
  components: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.GridContainer {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 10px;
}
</style>
